import { render } from "./NewDistributionCenter.vue?vue&type=template&id=4883b2b6"
import script from "./NewDistributionCenter.vue?vue&type=script&lang=js"
export * from "./NewDistributionCenter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__